/* eslint-disable react/destructuring-assignment */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable max-len */
import React, { useContext, useEffect, useMemo, useRef } from 'react';
import I18N from '@leverege/i18n';
import { AttributeValueEditors } from '@leverege/ui-attributes';
import { Form, Flex, Label, Pane, Text } from '@leverege/ui-elements';
import { BlueprintAttributeFormValidatorFactory } from "../validators/Factory.js";
import S from './ValueUpdateEditor.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t
} = I18N.ns('molten.imagine.forms.editors.ValueUpdateEditor');
const operationValues = {
  get default() {
    return [{
      name: t('edit'),
      value: 'edit'
    }, {
      name: t('clear'),
      value: 'clear'
    }];
  },
  get requiredAttr() {
    return [{
      name: t('edit'),
      value: 'edit'
    }];
  },
  get oneToOneRelAttr() {
    return [{
      name: t('clear'),
      value: 'clear'
    }];
  }
};
const useValueUpdateEffects = ({
  context,
  attr
}) => {
  const enabledName = `${attr.id}:enabled`;
  const operationName = `${attr.id}:operation`;
  const valueName = `${attr.id}:value`;
  const oldOperation = useRef(context.state.values[operationName]);
  const currrentEnabled = context.state.values[enabledName];
  const currentOperation = context.state.values[operationName];
  const currentValue = context.state.values[valueName];

  // Set enabled to true after changing the operation.
  useEffect(() => {
    if (oldOperation.current !== undefined && currentOperation !== undefined && oldOperation.current !== currentOperation || oldOperation.current === undefined && currentOperation !== undefined && currentOperation !== context.validator.getDefaultData()[operationName]) {
      context.validator.onInputChange({
        data: enabledName,
        value: true
      });
    }
    oldOperation.current = currentOperation;
  }, [currentOperation]);

  // Set enabled to true after changing the value.
  useEffect(() => {
    if (!currrentEnabled && !!currentValue) {
      context.validator.onInputChange({
        data: enabledName,
        value: true
      });
    }
  }, [currentValue]);

  // Set value to null after changing the operation to 'clear'.
  useEffect(() => {
    if (currentOperation === 'clear') {
      context.validator.onInputChange({
        data: valueName,
        value: null
      });
    }
  }, [currentOperation]);
};
function ValueUpdateEditor(props) {
  const {
    attr,
    targets
  } = props;
  const context = useContext(Form.Context);
  const enabledName = `${attr.id}:enabled`;
  const operationName = `${attr.id}:operation`;
  const valueName = `${attr.id}:value`;
  const operation = context.state.values[operationName];
  const required = useMemo(() => {
    const validatorType = attr.blueprint?.attribute?.getTagStartingWith?.('formValidator:', true) || attr.name;
    const validator = BlueprintAttributeFormValidatorFactory.create(validatorType, attr);
    if (validator) {
      const result = validator.submitValidator(null);
      return result === false || typeof result === 'string';
    }
    return false;
  }, [attr]);
  useValueUpdateEffects({
    context,
    attr
  });
  const onChange = evt => {
    const {
      data,
      value
    } = evt;
    if (attr.valueType === 'parentRelationship') {
      if (value?.type === 'add') {
        context.validator.onInputChange({
          data,
          value: value?.parentRef?.id
        });
      } else if (value?.type === 'remove') {
        context.validator.onInputChange({
          data,
          value: null
        });
      } else if (!value?.type) {
        Object.keys(value).forEach(field => {
          const v = value[field];
          if (v?.type === 'add') {
            context.validator.onInputChange({
              data: field,
              value: v?.parentRef?.id
            });
          } else if (v?.type === 'remove') {
            context.validator.onInputChange({
              data: field,
              value: null
            });
          }
        });
      }
    } else {
      context.validator.onInputChange({
        data,
        value
      });
    }
  };
  const getTitle = (cValue, values) => {
    if (cValue?.value == null) {
      return t('notSet');
    }
    return cValue?.name;
  };
  const valueEditor = useMemo(() => {
    const value = context.state.values[valueName];
    const error = context.state.hasError && context.state.submitErrors[valueName];
    const editor = AttributeValueEditors.getEditorFor(attr.name, targets[0].type);
    return editor?.create({
      // Used by all editors.
      attribute: attr,
      onChange,
      value,
      eventData: valueName,
      disabled: operation === 'clear',
      autoFocus: false,
      usage: 'form',
      ...(attr.valueType === 'enum' && {
        object: targets[0],
        editable: operation !== 'clear'
      }),
      ...(attr.valueType === 'resourceEnum' && {
        object: targets[0],
        editable: operation !== 'clear'
      }),
      ...(attr.valueType === 'boolean' && {
        editable: operation !== 'clear'
      }),
      ...(attr.valueType === 'timestamp' && {
        editable: operation !== 'clear'
      }),
      ...(attr.valueType === 'parentRelationship' && {
        object: targets[0],
        editable: operation !== 'clear',
        title: getTitle
      }),
      ...(attr.valueType === 'relationship' && {
        object: targets[0],
        editable: false
      }),
      ...(error && {
        className: S.error
      })
    });
  }, [attr, operation, context.state.values[valueName], context.state.hasError, context.state.submitErrors[valueName]]);
  const values = useMemo(() => {
    if (required) {
      return operationValues.requiredAttr;
    }
    if (attr.source.attribute?.relationshipType === 'oneToOne') {
      return operationValues.oneToOneRelAttr;
    }
    return operationValues.default;
  }, [attr]);
  return /*#__PURE__*/_jsxs(Flex, {
    variant: "rowL",
    align: "flex-start",
    children: [/*#__PURE__*/_jsxs(Flex, {
      variant: "rowL",
      align: "center",
      className: S.checkboxAndSelectorFlex,
      children: [/*#__PURE__*/_jsxs(Pane, {
        layout: "flex:colS",
        children: [/*#__PURE__*/_jsx(Form.Checkbox, {
          variant: "formInput",
          name: enabledName,
          disabled: !valueEditor
        }), context.validator.hasError(enabledName) && context.state.hasError && /*#__PURE__*/_jsx(Form.Error, {
          variant: "inputCaptionSmallError",
          name: enabledName
        })]
      }), /*#__PURE__*/_jsxs(Pane, {
        layout: "flex:colS",
        children: [/*#__PURE__*/_jsx(Form.Selector, {
          name: operationName,
          toggleVariant: "inputSelector|selector",
          nameKey: "name",
          valueKey: "value",
          values: values,
          disabled: required || !valueEditor,
          style: {
            width: 94
          }
        }), context.validator.hasError(operationName) && context.state.hasError && /*#__PURE__*/_jsx(Form.Error, {
          variant: "inputCaptionSmallError",
          name: operationName
        })]
      })]
    }), /*#__PURE__*/_jsxs(Flex, {
      variant: "colS",
      className: S.valueFlex,
      children: [/*#__PURE__*/_jsx(Label, {
        variant: "inputTitle",
        children: attr.displayName
      }), /*#__PURE__*/_jsx(Flex, {
        variant: "rowS",
        className: S.valueEditorFlex,
        align: "center",
        children: valueEditor ?? /*#__PURE__*/_jsx(Text, {
          variant: "inputValue",
          children: t('editorNotFound')
        })
      }), context.validator.hasError(valueName) && context.state.hasError && /*#__PURE__*/_jsx(Form.Error, {
        variant: "inputCaptionSmallError",
        name: valueName
      })]
    })]
  });
}
const type = 'valueUpdate';
export default {
  editor: ValueUpdateEditor,
  type
};